import { gql } from "@apollo/client";

export const GET_DOCUMENTOS_SEARCH = gql`
query GetDocumentosSearch($filter: DocumentoSearchFilterInput!) {
  documentosSearch(filter: $filter) {
    success,
    error,
    valorEsperado {
      idEvaluacion,
      idPaciente,
      paciente,
      cod_Cliente,
      cliente,
      fechaDesde,
      fechaHasta,
      modulo,
      idModulo,
      idTipoModulo,
      aC,
      c,
      rNH,
      rFK,
      p,
      v,
      dOC,
      pE,
      pG,
      nT,
      fN,
      pS,
      kN,
      tOC,
      aSS,
      eV,
      pSI,
      cantCnx,
      cantCnxPE,
      cantCnxVE,
      cantBolsas
    }
  }
}`;